import classNames from 'classnames';
import Link, { LinkProps } from 'next/link';
import { AnchorHTMLAttributes, FC, RefAttributes } from 'react';

import { fontColorMap, fontSizeMap, fontWeightMap, TextProps } from './TextBase';
import { LinkFragmentFragment } from '../../__generated__/graphql';
import { WithoutTypename } from '../../types';
import { convertHref } from '../../utils/convertHref';

import baseStyle from './text-base.module.css';
import style from './text-link.module.css';

interface LinkStyleProps {
  underlined?: boolean;
}
export type AppLinkProps =
  & { linkFragment: null | undefined | WithoutTypename<LinkFragmentFragment> }
  & Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'children' | 'href' | 'target' | keyof LinkProps>
  & Omit<LinkProps, 'href'>
  & RefAttributes<HTMLAnchorElement>;

type Props = AppLinkProps & LinkStyleProps & Omit<TextProps, 'as'>;

// Component Definition
const TextLink: FC<Props> = ({
  fontColor = 'inherit',
  fontSize = 14,
  fontWeight = 400,
  linkFragment,
  underlined,
  uppercase,
  ...props
}) => {
  if (!linkFragment) {
    return null;
  }

  return (
    <Link
      {...props}
      className={classNames(
        style.textLink,
        fontColorMap[fontColor],
        fontSizeMap[fontSize],
        fontWeightMap[fontWeight],
        {
          [style.textLinkUnderlined]: underlined,
        },
        {
          [baseStyle.uppercase]: uppercase,
        },
        props.className,
      )}
      href={convertHref(linkFragment.url)}
      target={linkFragment.target ?? undefined}
    >
      {props.dangerouslySetInnerHTML ? undefined : linkFragment.title}
    </Link>
  );
};

export default TextLink;
